import * as Sentry from "@sentry/react";
import { enableMapSet } from "immer";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./utils/i18n";
import { ensureMuiDataGridLicense } from "./utils/muiDataGridLicense";
import reportWebVitals from "./utils/reportWebVitals";
import {
  getSentryRuntimeConfig,
  SENTRY_NETWORK_DETAIL_ALLOW_URLS,
  SENTRY_TRACE_PROPAGATION_TARGETS,
} from "./utils/sentryConfig";

ensureMuiDataGridLicense();

const sentryConfig = getSentryRuntimeConfig();
if (sentryConfig) {
  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
    release: sentryConfig.release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        mask: [],
        block: [],
        networkDetailAllowUrls: SENTRY_NETWORK_DETAIL_ALLOW_URLS,
        networkRequestHeaders: ["X-Custom-Header"],
        networkResponseHeaders: ["X-Custom-Header"],
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
    tracePropagationTargets: SENTRY_TRACE_PROPAGATION_TARGETS,

    // This sets the sample rate to be 0%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  });
}

enableMapSet();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.error))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
